<section class="app-acc-hom-top">
  <swiper-container [config]="swiperConfig" class="app-acc-hom-top__swi" init="false" wwwSwiper>
    @for (b of banners(); let i = $index; track i) {
      <swiper-slide [ngClass]="{ 'app-acc-hom-top__swi__sl': true }" swiperSlide>
        <picture [appAnimate]="'fadeIn'" [speed]="'fast'">
          <source media="(max-width:990px)" [srcset]="b.imgMob" />
          <img class="bg" [priority]="true" alt="background" [ngSrc]="b.img" [fill]="true" />
        </picture>
        @if (activeSlideIndex() === i) {
          <div class="app-acc-hom-top__swi__sl__con" [appAnimate]="'fadeInUp'" [speed]="'fast'">
            <img
              src="assets/images/pro-connect-white.svg"
              alt="logo"
              height="27"
              width="271"
              class="app-acc-hom-top__swi__sl__con__log d-none d-md-block"
            />
            <img
              src="assets/images/pro-connect-black.svg"
              alt="logo"
              height="27"
              width="271"
              class="app-acc-hom-top__swi__sl__con__log d-block d-md-none"
            />
            <h2 class="app-acc-hom-top__swi__sl__con__tit">{{ b.title }}</h2>
            <div class="app-acc-hom-top__swi__sl__con__desc" [innerHtml]="b.desc"></div>
          </div>
        }
      </swiper-slide>
    }
  </swiper-container>
  @if (banners().length > 1) {
    <div class="app-acc-hom-top__swi--pag"></div>
  }
</section>
